import { TypeGuard } from '../../shared';
import { ChatData, ChatDataTypes } from './chat-data';

export interface HonourBoardChatData extends ChatData {
  agentKpis: HonourBoardKpi[];
  campaignId: number;
  group: string;
  total: HonourBoardKpi;
  type: 'honour-board';
  version:
    | 'v1'
    | 'v1u16'
    | 'conv1or2'
    | 'conv1or2or3'
    | 'conv3'
    | 'omnilead'
    | 'conv1'
    | 'conv1or2q150'
    | 'conv1or2q150u15'
    | 'conv1or2u15'
    | 'orderitem'
    | 'conv1cph'
    | 'conv1or2cph';
}

export interface HonourBoardKpi {
  contacts?: number;
  cph?: number;
  hours?: number;
  pledges?: number;
  ppc?: number;
  pph?: number;
  pps?: number;
  products?: number;
  rank: number;
  sales?: number;
  salesValue?: number;
  spc?: number;
  sph?: number;
  userId?: number;
  vph?: number;
  vps?: number;
}

export const isHonourBoard: TypeGuard<ChatDataTypes, HonourBoardChatData> = (
  data: ChatDataTypes
): data is HonourBoardChatData =>
  (data && data.type === 'honour-board') || false;
